import * as React from 'react'
import { ReactElement } from 'react'
import { useFormikContext } from 'formik'
import { Field, Input } from '@fluentui/react-components'
import { findValue } from '../../../components/Formik/FormikField'
import { formatPhoneNumber } from '../../helpers/phoneNumberHelper'

type Props = {
    label: string
    fieldName: string
    required?: boolean
}

/**
 * Fluent v9 phone-number field, Formik-bound: filters to valid characters (max 16) on change.
 * Replaces the legacy v8 `FormikPhoneNumberField` (not dark-mode compatible). Formatting lives in
 * {@link formatPhoneNumber}.
 */
export default function FormikPhoneNumberField(props: Props): ReactElement {
    const { values, errors, setFieldValue, handleBlur } = useFormikContext<any>()

    const error = findValue(errors, props.fieldName)

    return (
        <Field label={props.label} validationMessage={error} validationState={error ? 'error' : 'none'}>
            <Input
                value={findValue(values, props.fieldName) ?? ''}
                required={props.required}
                onChange={(_, data) => setFieldValue(props.fieldName, formatPhoneNumber(data.value))}
                onBlur={handleBlur(props.fieldName)}
                autoComplete="off"
                data-lpignore="true"
            />
        </Field>
    )
}
